export const IdTypes = {
    List: [
        {label: "VMS_VISITOR_ID_TYPE_ID", value: "01"},
        {label: "VMS_VISITOR_ID_TYPE_PASSPORT", value: "02"}
    ],
    Map: new Map<string, string>([
        ['01', 'VMS_VISITOR_ID_TYPE_ID'],
        ['02', 'VMS_VISITOR_ID_TYPE_PASSPORT'],
    ]),
    Enum: {
        idCard: "01",
        passport: '02',
    }
};
